import { render } from "./DeleteSvg.vue?vue&type=template&id=7411cc35&bindings={}"
import script from "./DeleteSvg.vue?vue&type=script&lang=ts"
export * from "./DeleteSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script